import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

const IMAGES = 'https://p1.liveauctioneers.com/dist/images/mid-century-and-modern-design';

export const twentiethCenturyDesignCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/furniture/', label: 'Furniture' },
        { href: '', label: '20th Century Design' },
    ],
    description:
        'Discover statement pieces from Eames, Herman Miller, Milo Baughman, Knoll, Gio Ponti and Danish Modern craftsmen — the names that defined an era of design.',
    layout: CollectionLayout.Collection,
    metaDescription:
        'Shop mid-century and modern design at auction — Eames, Herman Miller, Milo Baughman, Knoll, Gio Ponti and Danish Modern furniture from top auction houses.',
    searchParams: { category_id: '4', keyword: 'modern', status: 'online' },
    seoTitle: 'Mid-Century and Modern Design for Sale at Auction',
    slug: CollectionSlug.TwentiethCenturyDesign,
    subcategories: [
        {
            href: '/search/?keyword=herman%20miller&status=online',
            imageUrl: `${IMAGES}-herman-miller.png`,
            title: 'Herman Miller',
        },
        {
            href: '/search/?keyword=eames&status=online',
            imageUrl: `${IMAGES}-eames.png`,
            title: 'Eames',
        },
        {
            href: '/search/?category_id=4&keyword=knoll&status=online',
            imageUrl: `${IMAGES}-knoll.png`,
            title: 'Knoll',
        },
        {
            href: '/search/?keyword=milo%20baughman&status=online',
            imageUrl: `${IMAGES}-milo-baughman.png`,
            title: 'Milo Baughman',
        },
        {
            href: '/search/?keyword=gio&status=online',
            imageUrl: `${IMAGES}-glo-ponti.png`,
            title: 'Gio Ponti',
        },
        {
            href: '/search/?keyword=danish%20modern&status=online',
            imageUrl: `${IMAGES}-danish-modern.png`,
            title: 'Danish Modern',
        },
    ],
    title: 'Mid-Century and Modern Design',
};
